import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { pageMeta } from "../data/site";
import { useI18n } from "../i18n";

function upsertMeta(selector: string, attribute: "name" | "property", key: string, value: string) {
  let element = document.head.querySelector<HTMLMetaElement>(selector);
  if (!element) {
    element = document.createElement("meta");
    element.setAttribute(attribute, key);
    document.head.appendChild(element);
  }
  element.content = value;
}

export function Seo() {
  const { pathname } = useLocation();
  const { t } = useI18n();

  useEffect(() => {
    const route = pathname.replace(/\/+$/, "") || "/";
    const meta = pageMeta[route] ?? (route.startsWith("/account") ? pageMeta["/account"] : pageMeta["/"]);
    document.title = t(meta.title);
    upsertMeta('meta[name="description"]', "name", "description", t(meta.description));
    upsertMeta('meta[name="keywords"]', "name", "keywords", t(meta.keywords));
    upsertMeta('meta[property="og:title"]', "property", "og:title", t(meta.title));
    upsertMeta('meta[property="og:description"]', "property", "og:description", t(meta.description));
    upsertMeta('meta[property="og:url"]', "property", "og:url", window.location.href);
    upsertMeta('meta[name="robots"]', "name", "robots", pathname.startsWith("/account") ? "noindex,nofollow" : "index,follow");

    let canonical = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }
    canonical.href = new URL(route, window.location.origin).toString();
  }, [pathname, t]);

  return null;
}
